import React from 'react';
import searchImg from './img/search-2-line.png'
import clearImg from './img/close-line.png'

class ControlledInput extends React.Component {

    constructor(props) {
        super(props);
    }

    clear() {
        this.props.container.setState({[this.props.property]:''},
            this.props.onSubmit
        )
    }

    render() {
        const container = this.props.container
        const property = this.props.property
        const originValue = this.props.originProperty ? container.state[this.props.originProperty] : false
        const onSubmit = this.props.onSubmit

        let saveButton = ( this.props.withSaveButton && 
            !(this.props.originProperty&&(originValue==container.state[property])) ) ?
            <img src={searchImg} onClick={onSubmit}/> : ''

        // Clear button
        if (( !saveButton )&& this.props.withClearButton && container.state[property] && originValue ) {
            saveButton = <img src={clearImg} onClick={this.clear.bind(this)}/>
        }

        if (( !saveButton )&&( this.props.withClearButton || this.props.withSaveButton )) {
            saveButton = <span></span>
        }


        return <div className="controlled_input">
            <input 
                type={this.props.type} 
                value={container.state[property]} 
                name={property} 
                placeholder={this.props.placeholder}
                onChange={event=>{
                    container.setState({[property]:event.target.value})
                }}
                onKeyUp={e=>{
                    if (e.key === 'Enter') {
                        if ( onSubmit ) onSubmit()
                    }
            }}/>{saveButton}</div>
    }
}

export default ControlledInput;